if (!customElements.get('image-text-slider')) {
  class ImageTextSlider extends HTMLElement {
    arrows = undefined;
    selectors = {
      imageSlider: '[data-image-slider] .swiper',
    };
    options = {
      slidesPerView: 1,
      loop: false,
      effect: 'cards',
      cardsEffect: {
        perSlideRotate: 5,
        perSlideOffset: 5,
        slideShadows: true
      }
    };
    imageSlider = undefined;

    constructor() {
      super();
    }

    connectedCallback() {
      this.initImageSlider();
      this.imageSlider?.on('activeIndexChange', () => this.changeSlide(this.imageSlider.realIndex + 1));

      this.arrows = this.querySelectorAll('[data-slider-prev],[data-slider-next]');
      for (const arrow of this.arrows) {
        arrow.addEventListener('click', () => {
          arrow.hasAttribute('data-slider-next') ? this.imageSlider.slideNext() : this.imageSlider.slidePrev();
        });
      };

      
      // This block ensures that at least one slide is fully visible after initialization.
      // It repeatedly checks (up to maxIterations times, every 100ms) if any slide has the 'swiper-slide-fully-visible' class.
      // If not, it re-initializes the image slider to try to fix the visibility issue.
      // The interval is cleared once a fully visible slide is found or the maximum number of attempts is reached.
      let hasVisibleSlide = false;

      let iterationCount = 0;
      const maxIterations = 50;
      const intervalId = setInterval(() => {
        const allSlides = this.querySelectorAll('.swiper-slide');
        hasVisibleSlide = false; // Reset before checking

        allSlides.forEach(slide => {
          if (slide.classList.contains('swiper-slide-fully-visible')) {
            hasVisibleSlide = true;
          }
        });

        iterationCount++;
        if (!hasVisibleSlide && iterationCount < maxIterations) {
          this.initImageSlider();
        } else {
          clearInterval(intervalId);
        }
      }, 100);
    }

    /**
     * Changes text slide.
     *
     * @param {Number} index
     * @returns {void}
     */
    changeSlide(index) {
      const targetSlide = this.querySelector(`[data-slide-index="${index}"]`);
      if (!targetSlide) {
        return;
      }

      this.querySelector('[data-slide-index].is-active').classList.remove('is-active');
      targetSlide.classList.add('is-active');
    }

    /**
     * Init slider.
     */
    initImageSlider() {
      this.imageSlider = new Swiper(this.selectors.imageSlider, this.options);
    }
  }
  customElements.define('image-text-slider', ImageTextSlider);
}
